module.exports = __webpack_public_path__ + "img/card.f7b10036.svg";